/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Catalog_HintInputs */

const cs_property_ai_catalog_hint = /** @type {(inputs: Property_Ai_Catalog_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leták nemovitosti pro tisk a sdílení. Ukládá se i do Dokumentů, tady je rychle po ruce.`)
};

const en_property_ai_catalog_hint = /** @type {(inputs: Property_Ai_Catalog_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property flyer for print and sharing. Still stored in Documents, surfaced here for quick access.`)
};

/**
* | output |
* | --- |
* | "Property flyer for print and sharing. Still stored in Documents, surfaced here for quick access." |
*
* @param {Property_Ai_Catalog_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_catalog_hint = /** @type {((inputs?: Property_Ai_Catalog_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Catalog_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_catalog_hint(inputs)
	return cs_property_ai_catalog_hint(inputs)
});